import { Axios } from 'axios';
import {
  IAccountDetailsResDto,
  IAccountDetailsUpdateBody,
  ITrialStatusResDto,
} from 'components/SelfRegistration/types/dtos';
import apiClient, { IResponse } from 'services/api/axios';

class TrialService {
  api: Axios;

  constructor(api: Axios) {
    this.api = api;
  }

  getStatus() {
    return this.api.get<ITrialStatusResDto>('v2/trial/status');
  }

  getAccountDetails() {
    return this.api.get<IAccountDetailsResDto>('v2/trial/account-details');
  }

  updateAccountDetails(body: IAccountDetailsUpdateBody) {
    return this.api.put<IAccountDetailsResDto>('v2/trial/account-details', body);
  }

  requestExtension() {
    return this.api.post<IResponse>('v2/trial/extension-request');
  }
}

export default new TrialService(apiClient);
